var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfessional(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 997.94 612.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a27e2037-9522-4998-beff-03077fce3c95, .b5e3d395-8058-4117-baf4-10d10a9660a2, .b943e6ec-9f04-467d-a841-fba704852fb6 {\n        fill: #92d4cd;\n      }\n\n      .a0d26493-72aa-4149-9fd5-7cfcfb302278, .a27e2037-9522-4998-beff-03077fce3c95, .b1de1b9d-bd43-42b5-bf87-e23b4b01a8ac, .b75a447c-efb5-4058-b5be-18a1241bc7de, .b8190471-42ba-4cc9-8d2d-b81b25e49730, .e3e5c395-fd2f-401e-8cff-b75686a91f4a {\n        stroke: #231f20;\n      }\n\n      .a0d26493-72aa-4149-9fd5-7cfcfb302278, .a27e2037-9522-4998-beff-03077fce3c95, .b1de1b9d-bd43-42b5-bf87-e23b4b01a8ac, .b75a447c-efb5-4058-b5be-18a1241bc7de, .b8190471-42ba-4cc9-8d2d-b81b25e49730, .b925ece5-b38f-41b2-8738-0e7080a04b88, .b943e6ec-9f04-467d-a841-fba704852fb6, .bbe10fb2-4403-4e78-b730-43c957621e4f, .e3e5c395-fd2f-401e-8cff-b75686a91f4a, .e7d1e4ae-1075-400d-8436-69fe8cdce3e1, .fecfe600-5864-4422-8de0-454dc3d5e596 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .a27e2037-9522-4998-beff-03077fce3c95, .b8190471-42ba-4cc9-8d2d-b81b25e49730, .b925ece5-b38f-41b2-8738-0e7080a04b88 {\n        stroke-width: 6.48px;\n      }\n\n      .b69a3fdd-5497-4250-a2a6-6fe7174930e0 {\n        fill: #f4beb2;\n      }\n\n      .b943e6ec-9f04-467d-a841-fba704852fb6, .bbe10fb2-4403-4e78-b730-43c957621e4f, .e7d1e4ae-1075-400d-8436-69fe8cdce3e1 {\n        stroke: #000;\n      }\n\n      .b943e6ec-9f04-467d-a841-fba704852fb6, .e7d1e4ae-1075-400d-8436-69fe8cdce3e1, .fecfe600-5864-4422-8de0-454dc3d5e596 {\n        stroke-width: 7px;\n      }\n\n      .a0d26493-72aa-4149-9fd5-7cfcfb302278, .abe6df87-136d-4986-bf6b-63f59b555051, .b75a447c-efb5-4058-b5be-18a1241bc7de {\n        fill: #ee6e51;\n      }\n\n      .b1de1b9d-bd43-42b5-bf87-e23b4b01a8ac, .b8190471-42ba-4cc9-8d2d-b81b25e49730, .b925ece5-b38f-41b2-8738-0e7080a04b88, .bbe10fb2-4403-4e78-b730-43c957621e4f, .e3e5c395-fd2f-401e-8cff-b75686a91f4a, .e7d1e4ae-1075-400d-8436-69fe8cdce3e1, .fecfe600-5864-4422-8de0-454dc3d5e596 {\n        fill: none;\n      }\n\n      .b925ece5-b38f-41b2-8738-0e7080a04b88, .fecfe600-5864-4422-8de0-454dc3d5e596 {\n        stroke: #fff;\n      }\n\n      .b1de1b9d-bd43-42b5-bf87-e23b4b01a8ac, .b75a447c-efb5-4058-b5be-18a1241bc7de {\n        stroke-width: 3.78px;\n      }\n\n      .a0d26493-72aa-4149-9fd5-7cfcfb302278, .e3e5c395-fd2f-401e-8cff-b75686a91f4a {\n        stroke-width: 3.02px;\n      }\n\n      .b4655126-18b3-469b-9094-e275bb4e8ec6 {\n        fill: #fff;\n      }\n\n      .f83976a7-d66a-4b78-a9b0-0f2f7694eec4 {\n        fill: #231f20;\n      }\n\n      .bbe10fb2-4403-4e78-b730-43c957621e4f {\n        stroke-width: 6.24px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MedicalOrif") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a555aa8a-5b2c-40e3-9bb8-4b61db558070",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a832868e-edd7-4f45-a3dc-4de90811e3f6",
    "data-name": "colour"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "a27e2037-9522-4998-beff-03077fce3c95",
    points: "286.6 295.16 286.6 239.88 113.76 239.88 113.76 388.15 186.76 388.15 223.32 388.15 286.6 388.15 286.6 331.37 322.81 313.26 286.6 295.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b69a3fdd-5497-4250-a2a6-6fe7174930e0",
    d: "M42.68,531.8l-18,18.7c-3.43,3.56-2,10.42,2.49,11.67l33.17,9.31a5.91,5.91,0,0,1,3.64,3.3l14.21,30.34c2.27,4.85,8.07,4.57,9.87-.47l11-30.76a5.91,5.91,0,0,1,3.31-3.63l34.45-13.32c4.31-1.67,5.11-8.64,1.36-11.86l-21.93-18.8A7.61,7.61,0,0,1,114,519l6.67-29.81c1.18-5.32-3.16-10.11-7.39-8.15L79.65,502.64a4.64,4.64,0,0,1-3.49.17L40.63,484.45c-4.4-1.54-8.27,3.65-6.58,8.82l10.12,31A7.62,7.62,0,0,1,42.68,531.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b69a3fdd-5497-4250-a2a6-6fe7174930e0",
    d: "M971.4,318.81l19.5-6.4c3.71-1.22,5.23-6.55,2.58-9.07l-19.73-18.77a4.7,4.7,0,0,1-1.32-3.66l1.29-26.45c.21-4.22-4-6.17-7.07-3.32l-19,17.43a4.71,4.71,0,0,1-3.66,1.32l-29-3.44c-3.63-.43-6.77,4.14-5.34,7.78L918,295.48a6,6,0,0,1-1.17,5.93l-15.68,18.36c-2.8,3.27-1.53,8.23,2.14,8.43l31.5-2.69a3.64,3.64,0,0,1,2.5,1.17l18,26c2.5,2.71,7.12.51,7.86-3.72l4.4-25.42A6,6,0,0,1,971.4,318.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b69a3fdd-5497-4250-a2a6-6fe7174930e0",
    d: "M945.58,40.68l9.15-7.06c1.74-1.35,1.55-4.47-.34-5.31l-14-6.26A2.66,2.66,0,0,1,939,20.36l-4.28-14.3a2.29,2.29,0,0,0-4.38-.43l-6.83,12.83a2.66,2.66,0,0,1-1.7,1.39l-16,3.62c-2,.45-2.82,3.47-1.38,5.13l8.44,9.71a3.41,3.41,0,0,1,.49,3.38l-4.88,12.7c-.87,2.26.73,4.65,2.72,4.07l16.23-7.35a2,2,0,0,1,1.54.16l14.46,10.4c1.84,1,3.88-1.07,3.47-3.46l-2.43-14.32A3.39,3.39,0,0,1,945.58,40.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b69a3fdd-5497-4250-a2a6-6fe7174930e0",
    d: "M106.49,97.12l-5.84,7.45c-1.11,1.42-.32,3.86,1.34,4.15l12.38,2.14a2.15,2.15,0,0,1,1.45,1.06l6.29,10.48a1.87,1.87,0,0,0,3.56-.54l2.83-11.57a2.15,2.15,0,0,1,1.07-1.44l12-6.12c1.51-.77,1.54-3.33.06-4.35l-8.67-6a2.78,2.78,0,0,1-1.07-2.58l1.31-11.06c.23-2-1.52-3.55-3-2.69l-11.39,9.12a1.73,1.73,0,0,1-1.26.19L104,80c-1.65-.39-2.86,1.63-2.06,3.45l4.83,10.88A2.77,2.77,0,0,1,106.49,97.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b69a3fdd-5497-4250-a2a6-6fe7174930e0",
    d: "M21.07,194.61l6.64,6.76c1.26,1.28,3.78.82,4.28-.79l3.73-12A2.18,2.18,0,0,1,37,187.29l11.21-4.88a1.87,1.87,0,0,0-.07-3.6L37,174.5a2.16,2.16,0,0,1-1.29-1.25l-4.51-12.7c-.56-1.59-3.1-2-4.31-.61l-7.08,7.8a2.77,2.77,0,0,1-2.69.73L6.31,165.74c-1.92-.49-3.71,1-3,2.61l7.55,12.48a1.69,1.69,0,0,1,0,1.27l-7,12.77c-.61,1.59,1.24,3,3.15,2.49L18.35,194A2.78,2.78,0,0,1,21.07,194.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b943e6ec-9f04-467d-a841-fba704852fb6",
    d: "M658.14,377.21c-11.24-1.53-41.93-13.72-61.71-21.92,1.56,4.49,2.37,10.76,1,19.37-3.74,23.19-3.24,48.89-3.24,48.89,0,38,34.05,69.29,72.05,69.29A68.82,68.82,0,0,0,735,424s0-.26,0-.75c0-1.36-.07-2.7-.16-4-.6-11.76-3-42.62-12.54-64a23.74,23.74,0,0,1-1.56-15.92h0S675.28,379.55,658.14,377.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "abe6df87-136d-4986-bf6b-63f59b555051",
    points: "443.95 291.39 419.26 301.65 409 276.96 400.06 280.68 410.32 305.37 385.63 315.63 389.35 324.58 414.04 314.31 424.3 339 433.25 335.28 422.98 310.59 447.67 300.33 443.95 291.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b925ece5-b38f-41b2-8738-0e7080a04b88",
    d: "M270.31,106.32c.5.13,46.15,0,46.15,0l20.7-34.67,12.35,66.6L367,107h43.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b5e3d395-8058-4117-baf4-10d10a9660a2",
    d: "M345.14,158.9l-47.27-47.27c-30-30,17.3-77.25,47.27-47.28,30.92-30.91,78.19,16.36,47.28,47.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "abe6df87-136d-4986-bf6b-63f59b555051",
    d: "M427,32.46H254.11V180.73h73l18.28,36.56,18.28-36.56H427Zm-34.53,79.17L345.14,158.9l-47.27-47.27c-30-30,17.3-77.25,47.27-47.28C376.06,33.44,423.33,80.71,392.42,111.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b75a447c-efb5-4058-b5be-18a1241bc7de",
    x: 213.67,
    y: 255.17,
    width: 41.29,
    height: 7.1,
    rx: 3.55,
    transform: "translate(56.9 -41.89) rotate(11.62)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a0d26493-72aa-4149-9fd5-7cfcfb302278",
    x: 204.87,
    y: 365.8,
    width: 12.1,
    height: 7.7,
    transform: "translate(78.77 -34.9) rotate(11.62)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "abe6df87-136d-4986-bf6b-63f59b555051",
    points: "386.85 454.86 367.53 416.22 348.21 454.86 281.11 454.86 281.11 603.13 354.1 603.13 390.67 603.13 453.95 603.13 453.95 546.35 453.95 510.14 453.95 454.86 386.85 454.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b4655126-18b3-469b-9094-e275bb4e8ec6",
    d: "M373.53,529.86l16.72,4,5.86,18.8,13.79-14.07,16.63,4-25.75,23.76-4.91,20.4-15.09-3.63,4.91-20.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b5e3d395-8058-4117-baf4-10d10a9660a2",
    d: "M313.36,536.77l41-6.41L356,540.93l-25.66,4,1.23,7.87,23.8-3.72,1.58,10.1-23.81,3.72,1.53,9.76,26.41-4.13,1.75,11.21-41.74,6.52Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "afe37baf-038b-4fc9-9820-d7405944ca8b",
    "data-name": "line art"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "f83976a7-d66a-4b78-a9b0-0f2f7694eec4",
    cx: 806.64,
    cy: 416.22,
    rx: 9.35,
    ry: 11.12,
    transform: "translate(-75.18 631.4) rotate(-41.01)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f83976a7-d66a-4b78-a9b0-0f2f7694eec4",
    cx: 484.19,
    cy: 357.02,
    rx: 9.35,
    ry: 11.12,
    transform: "translate(-115.46 405.3) rotate(-41.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e7d1e4ae-1075-400d-8436-69fe8cdce3e1",
    d: "M695.1,16.93c-3.34-1.27-6.73-2.43-10.18-3.62C657.56-.24,626.56.76,598.28,13.17c-3.48,1.26-6.91,2.47-10.3,3.76-63.75,23.58-109.5,88.09-109.5,164,0,76.13,46.43,141,110.51,164.34,0,0,12.16,6.22,8.42,29.41s-3.24,48.89-3.24,48.89c0,38,34.05,69.29,72.05,69.29A68.82,68.82,0,0,0,735,424s0-.26,0-.75c0-1.36-.07-2.7-.16-4-.6-11.76-3-42.62-12.54-64-7.48-16.83,4.92-29.82,15.27-37.19a149.52,149.52,0,0,0,43.72-47.83,181.41,181.41,0,0,0,23.29-89.28C804.6,105,758.85,40.51,695.1,16.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e7d1e4ae-1075-400d-8436-69fe8cdce3e1",
    d: "M723.71,358.53c40.17-13.45,68-4.11,82.93,60"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e7d1e4ae-1075-400d-8436-69fe8cdce3e1",
    d: "M490.09,363.64c50,46.2,86.64,49.81,107.89,4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e7d1e4ae-1075-400d-8436-69fe8cdce3e1",
    d: "M617,473.38s-79.05,37.28-58.46,135.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e7d1e4ae-1075-400d-8436-69fe8cdce3e1",
    d: "M768.69,608.79s-83.56-37.56-76.92-120.85"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f83976a7-d66a-4b78-a9b0-0f2f7694eec4",
    cx: 546.99,
    cy: 225.95,
    r: 13.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f83976a7-d66a-4b78-a9b0-0f2f7694eec4",
    cx: 709.77,
    cy: 212.02,
    r: 13.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe10fb2-4403-4e78-b730-43c957621e4f",
    d: "M42.68,531.8l-18,18.7c-3.43,3.56-2,10.42,2.49,11.67l33.17,9.31a5.91,5.91,0,0,1,3.64,3.3l14.21,30.34c2.27,4.85,8.07,4.57,9.87-.47l11-30.76a5.91,5.91,0,0,1,3.31-3.63l34.45-13.32c4.31-1.67,5.11-8.64,1.36-11.86l-21.93-18.8A7.61,7.61,0,0,1,114,519l6.67-29.81c1.18-5.32-3.16-10.11-7.39-8.15L79.65,502.64a4.64,4.64,0,0,1-3.49.17L40.63,484.45c-4.4-1.54-8.27,3.65-6.58,8.82l10.12,31A7.62,7.62,0,0,1,42.68,531.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe10fb2-4403-4e78-b730-43c957621e4f",
    d: "M971.4,318.81l19.5-6.4c3.71-1.22,5.23-6.55,2.58-9.07l-19.73-18.77a4.7,4.7,0,0,1-1.32-3.66l1.29-26.45c.21-4.22-4-6.17-7.07-3.32l-19,17.43a4.71,4.71,0,0,1-3.66,1.32l-29-3.44c-3.63-.43-6.77,4.14-5.34,7.78L918,295.48a6,6,0,0,1-1.17,5.93l-15.68,18.36c-2.8,3.27-1.53,8.23,2.14,8.43l31.5-2.69a3.64,3.64,0,0,1,2.5,1.17l18,26c2.5,2.71,7.12.51,7.86-3.72l4.4-25.42A6,6,0,0,1,971.4,318.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe10fb2-4403-4e78-b730-43c957621e4f",
    d: "M945.58,40.68l9.15-7.06c1.74-1.35,1.55-4.47-.34-5.31l-14-6.26A2.66,2.66,0,0,1,939,20.36l-4.28-14.3a2.29,2.29,0,0,0-4.38-.43l-6.83,12.83a2.66,2.66,0,0,1-1.7,1.39l-16,3.62c-2,.45-2.82,3.47-1.38,5.13l8.44,9.71a3.41,3.41,0,0,1,.49,3.38l-4.88,12.7c-.87,2.26.73,4.65,2.72,4.07l16.23-7.35a2,2,0,0,1,1.54.16l14.46,10.4c1.84,1,3.88-1.07,3.47-3.46l-2.43-14.32A3.39,3.39,0,0,1,945.58,40.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe10fb2-4403-4e78-b730-43c957621e4f",
    d: "M106.49,97.12l-5.84,7.45c-1.11,1.42-.32,3.86,1.34,4.15l12.38,2.14a2.15,2.15,0,0,1,1.45,1.06l6.29,10.48a1.87,1.87,0,0,0,3.56-.54l2.83-11.57a2.15,2.15,0,0,1,1.07-1.44l12-6.12c1.51-.77,1.54-3.33.06-4.35l-8.67-6a2.78,2.78,0,0,1-1.07-2.58l1.31-11.06c.23-2-1.52-3.55-3-2.69l-11.39,9.12a1.73,1.73,0,0,1-1.26.19L104,80c-1.65-.39-2.86,1.63-2.06,3.45l4.83,10.88A2.77,2.77,0,0,1,106.49,97.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe10fb2-4403-4e78-b730-43c957621e4f",
    d: "M21.07,194.61l6.64,6.76c1.26,1.28,3.78.82,4.28-.79l3.73-12A2.18,2.18,0,0,1,37,187.29l11.21-4.88a1.87,1.87,0,0,0-.07-3.6L37,174.5a2.16,2.16,0,0,1-1.29-1.25l-4.51-12.7c-.56-1.59-3.1-2-4.31-.61l-7.08,7.8a2.77,2.77,0,0,1-2.69.73L6.31,165.74c-1.92-.49-3.71,1-3,2.61l7.55,12.48a1.69,1.69,0,0,1,0,1.27l-7,12.77c-.61,1.59,1.24,3,3.15,2.49L18.35,194A2.78,2.78,0,0,1,21.07,194.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e7d1e4ae-1075-400d-8436-69fe8cdce3e1",
    x: 356.49,
    y: 237.23,
    width: 120.31,
    height: 141.51,
    transform: "matrix(0.92, -0.38, 0.38, 0.92, -86.3, 183.53)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "e7d1e4ae-1075-400d-8436-69fe8cdce3e1",
    points: "443.95 291.39 419.26 301.65 409 276.96 400.06 280.68 410.32 305.37 385.63 315.63 389.35 324.58 414.04 314.31 424.3 339 433.25 335.28 422.98 310.59 447.67 300.33 443.95 291.39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e7d1e4ae-1075-400d-8436-69fe8cdce3e1",
    x1: 677.81,
    y1: 394.12,
    x2: 709.77,
    y2: 381.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "e7d1e4ae-1075-400d-8436-69fe8cdce3e1",
    d: "M345.14,158.9l-47.27-47.27c-30-30,17.3-77.25,47.27-47.28,30.92-30.91,78.19,16.36,47.28,47.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b925ece5-b38f-41b2-8738-0e7080a04b88",
    d: "M270.31,106.32c.5.13,46.15,0,46.15,0l20.7-34.67,12.35,66.6L367,107h43.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b8190471-42ba-4cc9-8d2d-b81b25e49730",
    points: "426.95 32.45 254.11 32.45 254.11 180.73 327.11 180.73 345.39 217.29 363.67 180.73 426.95 180.73 426.95 32.45"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "fecfe600-5864-4422-8de0-454dc3d5e596",
    points: "233.86 318.13 222.01 315.7 210.16 313.26 220.75 261.76 244.45 266.63 233.86 318.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "fecfe600-5864-4422-8de0-454dc3d5e596",
    x1: 212.07,
    y1: 364.04,
    x2: 210.16,
    y2: 313.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "fecfe600-5864-4422-8de0-454dc3d5e596",
    x1: 212.07,
    y1: 364.04,
    x2: 233.86,
    y2: 318.13
  })), /*#__PURE__*/React.createElement("rect", {
    className: "e3e5c395-fd2f-401e-8cff-b75686a91f4a",
    x: 204.87,
    y: 365.8,
    width: 12.1,
    height: 7.7,
    transform: "translate(78.77 -34.9) rotate(11.62)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b1de1b9d-bd43-42b5-bf87-e23b4b01a8ac",
    x: 213.67,
    y: 255.17,
    width: 41.29,
    height: 7.1,
    rx: 3.55,
    transform: "translate(56.9 -41.89) rotate(11.62)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b75a447c-efb5-4058-b5be-18a1241bc7de",
    x: 154.26,
    y: 255.22,
    width: 41.29,
    height: 7.1,
    rx: 3.55,
    transform: "translate(-30.55 23.52) rotate(-7.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a0d26493-72aa-4149-9fd5-7cfcfb302278",
    x: 182.25,
    y: 367.5,
    width: 12.1,
    height: 7.7,
    transform: "translate(-44.31 26.02) rotate(-7.08)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "fecfe600-5864-4422-8de0-454dc3d5e596",
    points: "193.51 315.19 181.51 316.69 169.5 318.18 163.03 266 187.04 263.02 193.51 315.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "fecfe600-5864-4422-8de0-454dc3d5e596",
    x1: 187.59,
    y1: 365.66,
    x2: 169.51,
    y2: 318.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "fecfe600-5864-4422-8de0-454dc3d5e596",
    x1: 187.59,
    y1: 365.66,
    x2: 193.51,
    y2: 315.19
  })), /*#__PURE__*/React.createElement("rect", {
    className: "e3e5c395-fd2f-401e-8cff-b75686a91f4a",
    x: 182.25,
    y: 367.5,
    width: 12.1,
    height: 7.7,
    transform: "translate(-44.31 26.02) rotate(-7.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b1de1b9d-bd43-42b5-bf87-e23b4b01a8ac",
    x: 154.26,
    y: 255.22,
    width: 41.29,
    height: 7.1,
    rx: 3.55,
    transform: "translate(-30.55 23.52) rotate(-7.08)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b8190471-42ba-4cc9-8d2d-b81b25e49730",
    points: "286.6 295.16 286.6 239.88 113.76 239.88 113.76 388.15 186.76 388.15 223.32 388.15 286.6 388.15 286.6 331.37 322.81 313.26 286.6 295.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b8190471-42ba-4cc9-8d2d-b81b25e49730",
    points: "386.85 454.86 367.53 416.22 348.21 454.86 281.11 454.86 281.11 603.13 354.1 603.13 390.67 603.13 453.95 603.13 453.95 546.35 453.95 510.14 453.95 454.86 386.85 454.86"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "e7d1e4ae-1075-400d-8436-69fe8cdce3e1",
    cx: 350.42,
    cy: 500.47,
    r: 5.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e7d1e4ae-1075-400d-8436-69fe8cdce3e1",
    cx: 373.7,
    cy: 501.71,
    r: 5.51
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e7d1e4ae-1075-400d-8436-69fe8cdce3e1",
    points: "355.93 500.76 357.75 466.67 381.02 467.91 379.2 502.01"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e7d1e4ae-1075-400d-8436-69fe8cdce3e1",
    x1: 380.51,
    y1: 477.43,
    x2: 357.24,
    y2: 476.19
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "e7d1e4ae-1075-400d-8436-69fe8cdce3e1",
    cx: 329.52,
    cy: 511.49,
    r: 5.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "e7d1e4ae-1075-400d-8436-69fe8cdce3e1",
    x1: 334.7,
    y1: 509.61,
    x2: 323.1,
    y2: 477.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "e7d1e4ae-1075-400d-8436-69fe8cdce3e1",
    cx: 394.73,
    cy: 511.49,
    r: 5.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "e7d1e4ae-1075-400d-8436-69fe8cdce3e1",
    d: "M400,513l9.4-32.83s-.33,10.51,8.07,10.51"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "e7d1e4ae-1075-400d-8436-69fe8cdce3e1",
    d: "M373.53,529.86l16.72,4,5.86,18.8,13.79-14.07,16.63,4-25.75,23.76-4.91,20.4-15.09-3.63,4.91-20.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e7d1e4ae-1075-400d-8436-69fe8cdce3e1",
    d: "M313.36,536.77l41-6.41L356,540.93l-25.66,4,1.23,7.87,23.8-3.72,1.58,10.1-23.81,3.72,1.53,9.76,26.41-4.13,1.75,11.21-41.74,6.52Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessional);
export default __webpack_public_path__ + "static/media/professional.119785b886d095282531cf168be56418.svg";
export { ForwardRef as ReactComponent };